// @flow

import React, { Component } from 'react'

import adminIcon from '../Icons/icon-admin-white.svg'
import adminCrown from '../Icons/icon-admin-blue.svg'
import appIcon from '../Icons/icon-app-white.svg'
import exploreIcon from '../Icons/icon-explore-white.svg'
import newsFeedIcon from '../Icons/icon-newsfeed-white.svg'
import overviewIcon from '../Icons/icon-overview-white.svg'
import individualIcon from '../Icons/icon-individual-white.svg'
import socialIcon from '../Icons/icon-social-white.svg'
import otherIcon from '../Icons/icon-other-white.svg'
import notificationIcon from '../Icons/icon-notification-menu-white.svg'
import './SubHeader.css'

type Props = {
  type: string,
  value: string
}

/**
  * Diplay for subheaders
  * @class
  * @extends Component
*/
class SubHeader extends Component<Props> {
  /** render function */
  render () {
    switch (this.props.type) {
      case 'App':
        return (
          <div className='subhead'>
            <div className='iconContain'><img alt='App Rocket' src={appIcon} /></div><div className='subTitle'><h2>App</h2> <p>Your application&apos;s activity</p></div>
          </div>
        )
      case 'Explore':
        return (
          <div className='subhead'>
            <div className='iconContain'><img alt='Explore Compass' src={exploreIcon} /></div><div className='subTitle'><h2>Explore</h2> <p>Your content&apos;s activity</p></div>
          </div>
        )
      case 'News Feed':
        return (
          <div className='subhead'>
            <div className='iconContain'><img alt='News Feed Paper' src={newsFeedIcon} /></div><div className='subTitle'><h2>Content</h2> <p>Content activity</p></div>
          </div>
        )
      case 'Admin':
        return (
          <div className='subhead'>
            <div className='iconContain'><img alt='Administrator Shield' src={adminIcon} /></div><div className='subTitle'><h2>Administrator</h2> <p>Your administrator&apos;s activity</p></div>
          </div>
        )
      case 'AdminDetails':
        return (
          <div className='subhead'>
            <div className='subTitle'><p><img alt='Administrator Crown' src={adminCrown} />Master Administrator Type</p></div>
          </div>
        )
      case 'Overview':
        return (
          <div className='subhead'>
            <div className='iconContain'><img alt='Overview Panels' src={overviewIcon} /></div><div className='subTitle'><h2> Dashboard</h2><p>A dashboard of your account level activities</p></div>
          </div>
        )
      case 'Individual':
        return (
          <div className='subhead'>
            <div className='iconContain'><img alt='Individual Person' src={individualIcon} /></div><div className='subTitle'><h2>User Activity</h2><p> Individual team member&apos;s activity</p></div>
          </div>
        )
      case 'Social':
        return (
          <div className='subhead'>
            <div className='iconContain'><img alt='Social Comment' src={socialIcon} /></div><div className='subTitle'><h2> Social</h2><p>Your team&apos;s social activity</p></div>
          </div>
        )
      case 'Notifications':
        return (
          <div className='subhead'>
            <div className='iconContain'><img alt='Other' src={notificationIcon} /></div><div className='subTitle'><h2> Notifications</h2><p>Notification activity</p></div>
          </div>
        )
      case 'Other':
        return (
          <div className='subhead'>
            <div className='iconContain'><img alt='Other' src={otherIcon} /></div><div className='subTitle'><h2> Other</h2><p>Other analytics from across your users</p></div>
          </div>
        )
      case 'NotificationDetails':
        return (
          <div className='subhead'>
            <div className='subTitle'><p>{this.props.value}</p></div>
          </div>
        )
      case 'SmsHistory':
        return (
          <div className='subhead'>
            <div className='subTitle'><h2>{this.props.value}</h2></div>
          </div>
        )
      default:
    }
  }
}
export default SubHeader
